import React, { useState, useEffect } from 'react';
import Mapas from '../../components/mapas';
import ImageSlider from '../../components/imageslider';
import { global } from '../../utils';
import './index.css';

export default function Numeros() {
  const empty = { "tit": "", "cap": "", "per": "" }
  const [localidad, setLocalidad] = useState(empty);
  const [municipios, setMunicipios] = useState({});
  const dataURL = `${global.managerURL}/data/municipios`;
  // const dataURL = `http://localhost:3000/municipios.json`;

  useEffect(() => {
    const fetchMunicipios = async () => {
      try {
        const response = await fetch(dataURL);
        if (!response.ok) throw new Error('Error al cargar los datos');
        const data = await response.json();
        setMunicipios(data);
      } catch (error) {
        console.error('Error al cargar municipios');
      }
    };
    fetchMunicipios();
  }, [dataURL]);
  
  const selectLocalidad = (e, item) => {
    e.preventDefault();
    const items = document.querySelectorAll('.mapa-container a path');
    items.forEach(item => { item.classList.remove('active'); });
    e.target.classList.add('active')
    setLocalidad(municipios[item] ? municipios[item] : empty);
  }

  return (
    <div className="wrapper numeros">
      <div className="numerosgrid">
        <div className='numerosgrid__intro'>
          <div className="head">
            <h4>Resultados del Programa</h4>
            <span className="logo"></span>
          </div>
          <div className="data">
            <div>
              <span>Capacitaciones en territorio:</span>
              <strong>179</strong>
            </div>
            <div>
              <span>Capacitaciones virtuales:</span>
              <strong>18</strong>
            </div>
            <div>
              <span>Total de personas capacitadas:</span>
              <strong>7.258</strong>
            </div>
          </div>
        </div>
        <div className='numerosgrid__mapa'>
          <div className="mapa-container">
            <Mapas onclick={selectLocalidad} localidad={localidad} />
          </div>
        </div>
        <div className="h5-container">
          <h5>Seleccioná una zona y conocé cuántas personas participaron de nuestros encuentros.</h5>
        </div>
      </div>
      <div className='numerosgrid__resultados'>
        {(localidad.tit !== "") && (
          <>
            <div className="resultadoscard localidad">
                <div>
                  <h6>Localidad:</h6>
                  <span>{localidad.tit}</span>
                </div>
              </div>
              <div className="resultadoscard numeros">
                <div>
                  <h6>Cantidad de capacitaciones:</h6>
                  <span>{localidad.cap}</span>
                </div>
                <div>
                  <h6>Personas<br />capacitadas:</h6>
                  <span>{localidad.per}</span>
                </div>
              </div>
            {/* PARADAS */}
            <div className="resultados_paradas">
            {(localidad.paradas && localidad.paradas.length > 0) ?
              (
                localidad.paradas.map((parada, index) => (
                  <div className="resultadoscard big paradas" key={index}>
                      <h4>Parada Incluir en Movimiento</h4>
                      <div>
                        <h6>Fecha: {parada.fecha}</h6>
                        <h6>Lugar:<br/>{parada.lugar}</h6>
                        <div className="cols">
                          <h6>Visitas<br />al espacio:</h6>
                          <span>{parada.visitas}</span>
                        </div>
                      </div>
                    </div>
                ))
              ) : (
                <div className="resultadoscard big paradas nodata">
                  <h4>Parada Incluir en Movimiento</h4>
                  <div>
                    <h6>Por el momento no se registran visitas al Municipio.</h6>
                  </div>
                </div>
              )
            }
            </div>
            <div className="resultados_red">
              {/* RICO EN DATA */}
              <div className="logocard big red">
                <h3>Rico en Data</h3>
              </div>
              {(localidad.rico_esc) ?
                (
                  <div className="resultadoscard big red">
                    <div>
                      <div className="cols">
                        <h6>Cantidad<br />de Escuelas:</h6>
                        <span>{localidad.rico_esc}</span>
                        <h6>Cantidad<br />de Cursos:</h6>
                        <span>{localidad.rico_cur}</span>
                        <h6>Cantidad<br />de Estudiantes:</h6>
                        <span>{localidad.rico_est}</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="resultadoscard big red nodata">
                    <div>
                      <h6>Por el momento no se registran visitas al Municipio.</h6>
                    </div>
                  </div>
                )
              }
            </div>
          </>
        )}
      </div>
      <ImageSlider galeria="numeros" />
    </div>
  );
}
